import {StyleSheet} from 'react-native';
import CommonStyles from '../../../utils/CommonStyles';
import {FONTS} from '../../../utils/Constants';

// Theme-aware styles factory (docs/DARK-MODE.md). The bottom sheet maps to
// surfaceElevated ('#fff' in light — same pixel as the legacy white).
const makeStyles = colors =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: colors.overlay,
      justifyContent: 'flex-end',
    },
    safeareaContainer: {
      backgroundColor: colors.surfaceElevated,
      borderTopLeftRadius: 24,
      borderTopRightRadius: 24,
      maxHeight: '90%',
    },
    bottomContainer: {
      padding: 24,
    },
    selectedChecBoxTitle: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 18,
      color: colors.textPrimary,
    },
    normalChecBoxTitle: {
      fontFamily: FONTS.regularFont,
      fontSize: 18,
      color: colors.textMuted,
    },
    buttonsContainer: {
      flexDirection: 'row',
      marginTop: 32,
    },
    button: {
      flex: 1,
    },
    marginTop24: {
      marginTop: 24,
    },
    h160: {
      height: 160,
    },
    w60: {
      width: 60,
    },
    timePickerText: {
      fontFamily: FONTS.semiboldFont,
      fontSize: 32,
    },
    ml16: {
      marginLeft: 16,
    },
    webContainer: {
      backgroundColor: colors.overlayLight,
      ...CommonStyles.flex_center,
    },
    detailsContainer: {
      width: 375,
      maxWidth: '90%',
      overflow: 'auto',
      ...CommonStyles.br_16,
    },
    webTextNonSelect: {
      MozUserSelect: 'none',
      WebkitUserSelect: 'none',
      msUserSelect: 'none',
      userSelect: 'none',
    },
    webButtonText: {
      fontSize: 16,
      fontFamily: FONTS.semiboldFont,
      lineHeight: 24,
      padding: 16,
      textAlign: 'center',
      borderRadius: 16,
      flex: 1,
    },
    webBorderedButtonText: {
      color: colors.link,
      borderWidth: 2,
      borderColor: colors.link,
    },
    webFilledButtonText: {
      color: colors.textOnAccent,
      backgroundColor: colors.link,
      marginLeft: 16,
    },
  });

export default makeStyles;
